import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="help"
export default class extends Controller {
  static targets = ["modal"];

  // Toggle the help modal visibility
  toggleModal() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.toggle("hidden");
    }
  }

  // Handle help option selection and open email client
  openHelpEmail(event) {
    const option = event.currentTarget.dataset.helpOption;
    let subject = "";
    let body =
      "Hello,\n\nI encountered an issue with WaveGuessr and would like to report it.\n\nProblem description:\n";

    switch (option) {
      case "media":
        subject = "WaveGuessr - Media not displaying (video/photo)";
        break;
      case "spot":
        subject = "WaveGuessr - The spot is wrong";
        break;
      case "other":
        subject = "WaveGuessr - Other issue";
        break;
    }

    const mailtoLink = `mailto:thomas@thesurfkit.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink);

    // Hide the modal after opening email
    if (this.hasModalTarget) {
      this.modalTarget.classList.add("hidden");
    }
  }

  // Close modal when clicking outside
  closeOnOutsideClick(event) {
    if (event.target === this.modalTarget) {
      this.modalTarget.classList.add("hidden");
    }
  }
}
